import { useState } from 'react';
import * as React from 'react';
import { EditBlock } from '../EditBlock/EditBlock';
import { OtherGroceriesModal } from '../OtherGroceriesModal/OtherGroceriesModal';

type OtherGroceriesProps = {
  heading: string;
  description: string;
  onDismiss?: () => void;
  icon: React.ReactNode;
  className?: string;
  customerId: number;
  containerId: number;
  onActionClick: (value: string) => void;
  modalHeading: string;
  initialValue?: number;
  editDisabled?: boolean;
};

export const OtherGroceries = (props: OtherGroceriesProps) => {
  const {
    heading,
    description,
    onDismiss,
    icon,
    className,
    customerId,
    containerId,
    onActionClick,
    modalHeading,
    initialValue,
    editDisabled,
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOnDismiss = () => {
    setIsModalOpen(false);
    onDismiss?.();
  };

  const handleOnActionClick = (value: string) => {
    onActionClick(value);
    setIsModalOpen(false);
  };

  return (
    <>
      <EditBlock
        className={className}
        icon={icon}
        heading={heading}
        description={description || 'None'}
        onClick={() => setIsModalOpen(true)}
        editDisabled={editDisabled}
      />
      {isModalOpen && (
        <OtherGroceriesModal
          isOpen={isModalOpen}
          customerId={customerId}
          containerId={containerId}
          onActionClick={handleOnActionClick}
          onDismiss={handleOnDismiss}
          heading={modalHeading}
          initialValue={initialValue}
        />
      )}
    </>
  );
};
